import React, {PureComponent as Component} from 'react';
import { XDiv } from "../../../ui/template/Layout/Layout";
import DataLoader from "../../../ui/template/Data/DataLoader";
import Child from "../../../ui/template/Children/Child";
import AppConfig from "../AppConfig"; 
import {MCbrowser} from "../../Context/browserContext";
import messageReadApi from "./Api/messageRead";

const columns=[
    { title:"",id:"", key: "", width: "5%",type: 'SelectRow', },
    { title:"شناسه", id:"1",key: "id", width: "10%",isOrder:true },
    { title:"کارشناس",id:"2", key: "userId", width: "10%",isOrder:true },
    { title:"  عنوان",id:"5", key: "title", width: "10%",isOrder:true },
    { title:"پیام", id:"6",key: "message", width: "40%" },
    { title:"تاریخ ثبت",id:"4", key: "createdAt", width: "10%",isOrder:true },
    { title:"", key: "endCol", width: "10%",isLink:true, type: 'Links', },
];

class  Message extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.queryFilters="";
        this.listFilters={};
        this.table1=React.createRef();
        this.HreadMessage=this.readMessage.bind(this);
        this.HfunCV=this.funCV.bind(this);
        this.props=props;
        this.rowsId=0;
    }

    readMessage(mId) {
        let pageAlerts = this.context.pageAlerts;
        messageReadApi(mId ,pageAlerts,this.formAlerts);
    }


    funCV(data,ts,recordKey,selectFun=null){ 
        let rows=[]; 
        let l=data.length;  
        for (let i=0;i<l;i++){
            this.rowsId++;
            let el=null;
            if(i%2===0){
                el= <div key={data[i].id} className="p-3 d-flex align-items-center bg-light border-bottom osahan-post-header">
                    <div className="dropdown-list-image mr-3">
                        <img className="rounded-circle"  src="http://mdyaran.ir/membership/picture"  alt="" />
                    </div>
                    <div className="font-weight-bold mr-3">
                        <div className="text-truncate">
                            {data[i].title}
                        </div>
                        <div className="small">
                            {data[i].message}
                        </div>
                    </div>
                </div>;
            }else{
                el= <div className="p-3 d-flex align-items-center osahan-post-header">
                    <div className="dropdown-list-image mr-3">
                        <img className="rounded-circle"  src="http://mdyaran.ir/membership/picture"  alt="" />
                    </div>
                    <div className="font-weight-bold mr-3">
                        <div className="text-truncate">
                            {data[i].title}
                        </div>
                        <div className="mb-2">
                            {data[i].message}
                        </div>
                    </div>
                </div>;
            }
            rows.push(el);
        } 
        ts.cv=<><XDiv  className="timeline-wrapper"> 
        <XDiv  className="timeline-wrapper-inner"> 
        <XDiv  className="timeline-container"> 
        {rows}
        </XDiv>
        </XDiv>
        </XDiv> </>;
    }

   

    render() {
        return (
            <React.Fragment>
                <div className="box shadow-sm border rounded bg-white mb-3">
                    <div className="box-title border-bottom p-3">
                        <h6 className="m-0">
                          اطلاعیه ها

                        </h6>
                    </div>
                    <div className="box-body p-0">
                        <DataLoader ref={this.table1} scope="route" name="message"
                                    baseUrl={AppConfig.base_url} selectable={false}
                                    columns={columns} orderColumn={1} orderDir={2} isHeader={false}
                                    funCustomVeiw={ this.HfunCV} isCustomVeiw={true} className=""
                                    srcName="message"  queryFields="id,title,message,userId,createdAt,isRead">
                            <Child type="navbar">
                            </Child>
                            <Child type="links">
                            </Child>
                        </DataLoader>
                    </div>
                </div>
            </React.Fragment>
        );

    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        let page = this.context.page;
        page.dispatcher.removeScopeName("route","message");

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

Message.contextType = MCbrowser;

export default Message;
